/* v8 ignore start */
import { v4 as uuidv4 } from 'uuid';

export const uuid = () => uuidv4();
/* v8 ignore end */
